import { Platform } from '@angular/cdk/platform';

export class NbPlatform extends Platform {}
